// ===========================================================================
// Notas clínicas TERMINADAS pendientes de firma en AdvancedMD — store local.
//
// TODO(backend): la nota terminada en CDCI todavía NO se inserta en AdvancedMD
// desde el flujo normal (solo existe la inserción dev contra el paciente de
// prueba). Mientras tanto, al cerrar el encuentro la nota queda guardada ACÁ
// (localStorage — sobrevive al F5, a diferencia del sessionStore del CDCI) y
// alimenta el panel de alertas del Layout: "nota pendiente de firma — por
// favor fírmela en AdvancedMD". Cuando exista la inserción productiva + el
// endpoint GET /api/Alerts/unsigned-notes, este store se reemplaza por la
// llamada real manteniendo la misma forma de retorno.
//
// Un registro por cita (recerrar reemplaza). Cambios notificados por window
// event para que el AlertsContext refresque sin recargar la página.
// ===========================================================================

const STORAGE_KEY = "mcm_cdci_pending_sign_notes.v1";

/** Evento de ventana disparado en cada cambio del store. */
export const PENDING_NOTES_EVENT = "mcm:pending-sign-notes-changed";

const read = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const write = (list) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch {
    // localStorage lleno o bloqueado: el aviso vivirá solo en esta sesión.
  }
  try {
    window.dispatchEvent(new Event(PENDING_NOTES_EVENT));
  } catch {
    // Sin window (tests): no hay a quién avisar.
  }
};

/**
 * Notas terminadas pendientes de firma, la más reciente primero.
 *
 * @returns {Array<{appointmentId:string, templateName:string, patientName:string,
 *   chartNumber:string, reason:string, serviceDate:string, completedAt:string,
 *   fields:Object}>}
 */
export const getPendingSignNotes = () =>
  read().sort((a, b) => String(b.completedAt || "").localeCompare(String(a.completedAt || "")));

/**
 * Registra (o reemplaza, por cita) una nota terminada pendiente de firma.
 * Guarda también el snapshot de `fields`: es la copia que sobrevive al F5
 * mientras la nota no viva en AdvancedMD.
 *
 * @param {Object} entry
 * @param {number|string} entry.appointmentId
 * @param {string} entry.templateName
 * @param {string} [entry.patientName]
 * @param {string} [entry.chartNumber]
 * @param {string} [entry.reason]
 * @param {string} [entry.serviceDate] - ISO; default: ahora
 * @param {Object} [entry.fields] - snapshot de los campos de la nota
 * @returns {Object} el registro guardado
 */
export const addPendingSignNote = (entry) => {
  const record = {
    appointmentId: String(entry.appointmentId),
    templateName: entry.templateName || "Clinical note",
    patientName: entry.patientName || "—",
    chartNumber: entry.chartNumber || "",
    reason: entry.reason || "",
    serviceDate: entry.serviceDate || new Date().toISOString(),
    completedAt: new Date().toISOString(),
    fields: entry.fields || {},
  };
  const rest = read().filter((n) => n.appointmentId !== record.appointmentId);
  write([record, ...rest]);
  return record;
};

/**
 * Quita una nota del store (p. ej. cuando se confirme firmada en AdvancedMD).
 *
 * @param {number|string} appointmentId
 */
export const removePendingSignNote = (appointmentId) => {
  write(read().filter((n) => n.appointmentId !== String(appointmentId)));
};
